import React, { useState } from 'react';
import PatientCheckIn from '../components/PatientCheckIn';
import AppointmentScheduler from '../components/AppointmentScheduler';
import AppointmentManager from '../components/AppointmentManager';
import PatientRecords from '../components/PatientRecords';
import ChatBot from '../components/ChatBot';
import './FrontDesk.css';

function FrontDesk({ onLogout }) {
  const [activeView, setActiveView] = useState('appointments'); // checkin, appointments, manage, patients

  // Get username from localStorage (stored as JSON by Login component)
  const getUsernameFromStorage = () => {
    try {
      const userJson = localStorage.getItem('user');
      if (userJson) {
        const user = JSON.parse(userJson);
        return user.username || user.name || 'User';
      }
    } catch (error) {
      console.error('Failed to parse user from localStorage:', error);
    }
    return 'User';
  };

  const username = getUsernameFromStorage();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      if (onLogout) onLogout();
    }
  };

  return (
    <div className="front-desk">
      {/* Header */}
      <div className="front-desk-header">
        <div className="logo-section">
          <h1>Medical Office Front Desk</h1>
          <p>Patient Management System</p>
        </div>
        <div className="header-right">
          <div className="user-info">
            <span className="user-icon">👤</span>
            <span className="username">{username}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            🚪 Logout
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="nav-section">
        <div className="nav-tabs">
          <button
            className={`nav-tab ${activeView === 'checkin' ? 'active' : ''}`}
            onClick={() => setActiveView('checkin')}
          >
            ✓ Check-In
          </button>
          <button
            className={`nav-tab ${activeView === 'appointments' ? 'active' : ''}`}
            onClick={() => setActiveView('appointments')}
          >
            📅 Schedule Appointment
          </button>
          <button
            className={`nav-tab ${activeView === 'manage' ? 'active' : ''}`}
            onClick={() => setActiveView('manage')}
          >
            📋 Manage Appointments
          </button>
          <button
            className={`nav-tab ${activeView === 'patients' ? 'active' : ''}`}
            onClick={() => setActiveView('patients')}
          >
            👥 Patient Records
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="front-desk-content">
        <div className="content-container">
          {activeView === 'checkin' && (
            <div className="view-section">
              <PatientCheckIn />
            </div>
          )}

          {activeView === 'appointments' && (
            <div className="view-section">
              <AppointmentScheduler />
            </div>
          )}

          {activeView === 'manage' && (
            <div className="view-section">
              <AppointmentManager />
            </div>
          )}

          {activeView === 'patients' && (
            <div className="view-section">
              <PatientRecords />
            </div>
          )}
        </div>

        {/* Side Panel - Always visible */}
        <div className="side-panel">
          <div className="info-card">
            <h3>System Status</h3>
            <div className="status-item">
              <span className="status-dot online"></span>
              <span>OpenEMR Connected</span>
            </div>
            <div className="status-item">
              <span className="status-dot online"></span>
              <span>System Active</span>
            </div>
          </div>

          <div className="info-card">
            <h3>EMR Access</h3>
            <p className="card-description">Access the full EMR system</p>
            <button
              className="openemr-login-btn"
              onClick={() => window.open('https://emr.works', '_blank')}
            >
              <span className="icon">🏥</span>
              <span>Login to EMR</span>
            </button>
            <p className="help-text">Opens in a new window</p>
          </div>

          <div className="info-card">
            <h3>Today's Stats</h3>
            <div className="stat-row">
              <span>Appointments:</span>
              <span className="stat-value">12</span>
            </div>
            <div className="stat-row">
              <span>Checked In:</span>
              <span className="stat-value">8</span>
            </div>
            <div className="stat-row">
              <span>Pending:</span>
              <span className="stat-value">4</span>
            </div>
          </div>

          <div className="info-card">
            <h3>Quick Actions</h3>
            <ul className="command-list">
              <li>Check in patients</li>
              <li>Schedule appointments</li>
              <li>Register new patients</li>
              <li>View patient records</li>
              <li>Manage appointments</li>
            </ul>
          </div>
        </div>
      </div>

      {/* AI Chat Assistant */}
      <ChatBot />
    </div>
  );
}

export default FrontDesk;
